import { useRouter } from 'next/router';

import { STALE_TIME } from '~/domains/contest/constants/query';
import { useDefaultSlate } from '~/domains/games/hooks/useDefaultSlate';

import { useContestUserEntries } from '../../../../../../hooks/useContestUserEntries';
import { useContestTeamPicks } from '../../../../../../hooks/useContestTeamPicks';

type UseMyContestEntries = {
  pageSize?: number;
  scheduleId?: string;
  enabled?: boolean;
};

const useMyContestEntries = ({ pageSize = 20, scheduleId, enabled }: UseMyContestEntries) => {
  const router = useRouter();
  const { contestUuid } = router.query;

  const defaultSlate = useDefaultSlate(scheduleId, {
    enabled: !!scheduleId,
    staleTime: STALE_TIME,
  });

  const contestId = contestUuid as string;

  const userEntries = useContestUserEntries({ contestId, pageSize, enabled });
  const entries = userEntries.data;
  const teamPicks = useContestTeamPicks({
    entryIds: entries?.data?.map(({ id }) => id) || [],
  });

  return {
    teamPicks,
    userEntries,
    defaultSlate,
  };
};

export default useMyContestEntries;
